import { render, staticRenderFns } from "./collateral-add-widget.vue?vue&type=template&id=91cab5a0&scoped=true&"
import script from "./collateral-add-widget.vue?vue&type=script&lang=js&"
export * from "./collateral-add-widget.vue?vue&type=script&lang=js&"
import style0 from "./collateral-add-widget.vue?vue&type=style&index=0&id=91cab5a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91cab5a0",
  null
  
)

export default component.exports